export default __webpack_public_path__ + "static/media/Degrees.7cd16c61.jpg";